module.exports = __webpack_public_path__ + "img/xj.3be562d8.png";